import { PropertyStatus } from '@dreamstack/real-estate-logic'
import orderBy from 'lodash/orderBy'

const StatusOrder: Record<PropertyStatus, number> = {
  [PropertyStatus.FREE]: 1,
  [PropertyStatus.BLOCKED]: 9,
  [PropertyStatus.NOT_AVAILABLE]: 9,
  [PropertyStatus.RESERVED]: 5,
  [PropertyStatus.SOLD]: 9,
  [PropertyStatus.FREE_STOP_AD]: 1,
  [PropertyStatus.FREE_EXCLUSIVE_COOP]: 1,
  [PropertyStatus.PRERESERVED]: 5,
  [PropertyStatus.RESERVATION_EXTENSION_1]: 5,
  [PropertyStatus.RESERVATION_EXTENSION_2]: 5,
  [PropertyStatus.RESERVATION_EXTENSION_3]: 5,
  [PropertyStatus.DECLARATION_OF_PURCHASE_INTENTION]: 5,
  [PropertyStatus.FREE_EXCLUSIVE_SALES_CONSULTANT]: 1,
}

export const sortPropertiesByStatus = <T extends { status: number | null }>(
  properties: T[]
) => {
  return orderBy(
    properties,
    ({ status }) => {
      return StatusOrder[status as PropertyStatus]
    },
    'asc'
  )
}

export const sortPropertiesByName = <T extends { name: string }>(
  properties: T[]
) => {
  return orderBy(
    properties,
    (p) => {
      // try to parse the name as a number
      // usually its formatted like this: 1234-11
      const nameWithoutDash = p.name.replace(/-/g, '')
      const parsed = parseInt(nameWithoutDash, 10)
      if (!isNaN(parsed)) {
        return parsed
      }
      return p.name
    },
    'asc'
  );
}

export const sortPropertiesByFloor = <T extends { floor: string | null }>(
  properties: T[]
) => {
  return orderBy(
    properties,
    (p) => {
      return p.floor
    },
    'asc'
  )
}
